<h1 mat-dialog-title>{{ 'dialogs.chooseRole.title' | translate }}</h1>
<mat-dialog-content>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <mat-form-field class="col-12">
            <mat-label>
              {{ 'dialogs.chooseRole.roleLabel' | translate }}
            </mat-label>
            <mat-select [(value)]="chosenRole">
              <mat-option *ngFor="let element of userRoles; let i = index" [value]="element._id">
                <span *ngIf="element.role.name === 'Admin'">{{ 'roles.types.admin' | translate }}</span>
                <span *ngIf="element.role.name === 'Operator'">{{ 'roles.types.operator' | translate }}</span>
                <span *ngIf="element.role.name === 'Master'">
                  {{ 'roles.types.master' | translate }}
                  {{ element.company ? ' - ' + element.company.name : '' }}
                </span>
                <span *ngIf="element.role.name === 'Collaborator'">
                  {{ 'roles.types.collaborator' | translate }}
                  {{ element.company ? ' - ' + element.company.name : '' }}
                </span>
                <span *ngIf="element.role.name === 'Temporary'">
                  {{ 'roles.types.temporary' | translate }}
                  {{ element.company ? ' - ' + element.company.name : '' }}
                </span>
                <small *ngIf="i === 0"> {{ 'dialogs.chooseRole.currentRole' | translate }}</small>
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div> <!-- /.form-group -->
      </div> <!-- /.col -->
    </div> <!-- /.row -->
  </div> <!-- /.container -->
</mat-dialog-content> <!-- mat-dialog-content -->
<mat-dialog-actions align="end">
  <button mat-button (click)="onClose(chosenRole)" mat-raised-button
    mat-primary>{{ 'common.cta.ok' | translate }}</button>
</mat-dialog-actions> <!-- /.mat-dialog-actions -->